
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ops",
      function () {
        return require("private-next-pages/ops.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ops"])
      });
    }
  